export default __webpack_public_path__ + "static/media/595.07958588.png";